<template>
  <div class="login-bg">
    <div class="logo"></div>
    <div class="title">为实体门店赋能，为中小品牌发声</div>
    <div class="login-box">
      <el-form ref="form" :model="form">
        <el-tabs v-model="activeName" @tab-click="activeLogin">
          <el-tab-pane label="快捷登录" name="first">
            <el-form-item prop="username">
              <el-input
                autocomplete="off"
                v-model="form.username"
                prefix-icon="el-icon-user"
                placeholder="手机号"
                @keyup.native.enter="focusNext('password')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="pwd">
              <el-input
                @keyup.native.enter="focusNext('login')"
                ref="password"
                autocomplete="off"
                type="password"
                v-model="form.pwd"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
              ></el-input>
            </el-form-item>
            <!--            <el-form-item class="rember-pwd">-->
            <!--              <div class="rember-password">-->
            <!--                <el-checkbox v-model="remberPhone">记住用户</el-checkbox>-->
            <!--                <router-link-->
            <!--                  to="/phone/changePwd"-->
            <!--                >-->
            <!--                  <div class="forgetPassword">忘记密码?</div>-->
            <!--                </router-link>-->
            <!--              </div>-->
            <!--            </el-form-item>-->
          </el-tab-pane>
          <el-tab-pane label="普通登录" name="second">
            <el-form-item prop="merchantNo">
              <el-input
                autocomplete="off"
                v-model="form.merchantNo"
                prefix-icon="el-icon-s-shop"
                placeholder="商户号"
                @keyup.native.enter="focusCodeNext('username')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="username">
              <el-input
                ref="username"
                autocomplete="off"
                v-model="form.username"
                prefix-icon="el-icon-user"
                placeholder="工号"
                @keyup.native.enter="focusCodeNext('pwd')"
              ></el-input>
            </el-form-item>
            <el-form-item prop="pwd">
              <el-input
                ref="pwd"
                readonly
                onfocus="this.removeAttribute('readonly') "
                autocomplete="off"
                type="password"
                v-model="form.pwd"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
                @keyup.native.enter="focusNext('login')"
              ></el-input>
            </el-form-item>
            <!--            <el-form-item class="rember-pwd">-->
            <!--              <div class="rember-password">-->
            <!--                <el-checkbox v-model="remberPassword">记住用户</el-checkbox>-->
            <!--                <router-link-->
            <!--                  to="/phone/changePwd"-->
            <!--                >-->
            <!--                  <div class="forgetPassword">忘记密码?</div>-->
            <!--                </router-link>-->
            <!--              </div>-->
            <!--            </el-form-item>-->
          </el-tab-pane>
        </el-tabs>
        <el-form-item class="rember-pwd">
          <div class="rember-password">
            <el-checkbox v-model="remberPassword">记住用户</el-checkbox>
            <router-link to="/phone/changePwd">
              <div class="forgetPassword">忘记密码?</div>
            </router-link>
          </div>
        </el-form-item>
        <el-form-item class="rember-pwd">
          <el-button
            ref="login"
            type="primary"
            @click="login"
            class="login-btn"
            :loading="loading"
          >登录
          </el-button
          >
        </el-form-item>
        <el-form-item prop="agreement" class="rember-pwd">
          <div class="">
            <el-checkbox v-model="form.agreement"
            >登录表示您已阅读并同意
            </el-checkbox
            >
            <router-link to="/userAgreement" target="_blank">
              <span style="color:#458cff;cursor:pointer">《用户协议》</span>
            </router-link>
          </div>
        </el-form-item>
      </el-form>
      <div class="regist">
        没有账号?点击<span
        style="color:#458cff;cursor:pointer"
        @click="$router.push('/regist')"
      >注册</span
      >
      </div>
    </div>
    <m-footer></m-footer>
  </div>
</template>
<script>
import api from "@/config/api";
import footer from "@/components/business/footer";
import qs from "qs";

export default {
  components: {
    mFooter: footer
  },
  data() {
    return {
      isHasInviteCode: false,
      activeName: "first",
      remberPassword: false,
      remberPhone: false,
      form: {
        merchantNo: "",
        username: "",
        password: "",
        pwd: "",
        agreement: true
      },
      rememberUser: false,
      loading: false
    };
  },
  created() {
    this.form.username = this.$utils.getUserName();
    let currentUrl = window.location.href; //获取当前链接
    if (
      currentUrl.indexOf("?") != -1 &&
      currentUrl.indexOf("username") != -1 &&
      currentUrl.indexOf("password") != -1 &&
      currentUrl.indexOf("merchantNo") != -1
    ) {
      this.andLogin();
    }
    this.activeLogin({name: "first"});
  },
  methods: {
    // 切换快捷
    activeLogin(val) {
      this.form = {
        merchantNo: "",
        username: "",
        password: "",
        pwd: "",
        agreement: true
      };
      // this.remberPassword = false
      // this.remberPhone = false
      // 读取cookie是否记住密码
      // 在页面加载时从cookie获取登录信息
      let phone = this.$utils.getCookie("phone");
      // let phonePwd = this.$utils.getCookie("phonePwd")
      let username2 = this.$utils.getCookie("username2");
      let username1 = this.$utils.getCookie("username1");
      // let merchantPwd = this.$utils.getCookie("merchantPwd")
      // 如果存在赋值给表单，并且将记住密码勾选
      if (val.name === "first") {
        if (phone) {
          this.form.username = phone;
          // this.form.pwd = phonePwd
          // this.remberPhone = true
          this.remberPassword = true;
        } else {
          this.remberPassword = false;
        }
      }
      if (val.name === "second") {
        if (username1) {
          this.form.username = username2;
          this.form.merchantNo = username1;
          // this.form.pwd = merchantPwd
          this.remberPassword = true;
        } else {
          this.remberPassword = false;
        }
      }
    },
    // 工号登录 enter
    focusCodeNext(val) {
      this.$refs[val].focus();
    },
    focusNext(nextRef) {
      if (nextRef == "login") {
        this.login();
      } else {
        this.$refs[nextRef].focus();
      }
    },
    // 安卓端登录
    andLogin() {
      localStorage.clear();
      let params = {
        username: this.getCurrentUrl("username"),
        password: this.getCurrentUrl("password"),
        merchantNo: this.getCurrentUrl("merchantNo")
      };
      this.$axios
        .fetchPost(api.login, qs.stringify(params), {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          loginType: 10
        })
        .then(data => {
          this.loading = false;
          if (data.code == 200) {
            this.$utils.setSysUser(data.data.user || {});
            this.$utils.setUserMenu(data.data.menu || {});
            this.$utils.setSessionID(data.data.key);
            this.$router.push({path: "/index"});
            this.getCacheData();
          } else {
            this.$message({message: data.message + data.code, type: "error"});
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message({message: err.msg, type: "error"});
        });
    },
    // 获取url参数
    getCurrentUrl(param) {
      var currentUrl = window.location.href; //获取当前链接
      // var currentUrl = 'http://322n599v37.qicp.vip?username=5002&password=123&merchantNo=88223123'
      var urlArr = currentUrl.split("?");
      if (urlArr.length > 1) {
        urlArr = urlArr[1].split("&"); //分割参数
        for (var i = 0; i < urlArr.length; i++) {
          var tem = urlArr[i].split("="); //分割参数名和参数内容
          if (tem[0] == param) {
            return tem[1];
          }
        }
        return null;
      } else {
        return null;
      }
    },
    login() {
      this.$store.commit(this.$utils.storeKeys.CLICKMENU, []); //清除导航菜单按钮
      if (this.activeName == "first") {
        if (!this.form.username || !this.form.pwd) {
          this.$message({message: "请输入手机号和密码！", type: "error"});
          return;
        }
      } else {
        if (!this.form.username || !this.form.pwd || !this.form.merchantNo) {
          this.$message({
            message: "请输入商户号、工号和密码！",
            type: "error"
          });
          return;
        }
      }
      if (!this.form.agreement) {
        this.$message({message: "请先阅读协议！", type: "error"});
        return;
      }
      if (this.form.pwd.length > 30) {
        this.form.password = this.form.pwd;
      } else {
        this.form.password = this.$utils.md5(this.form.pwd);
      }
      this.loading = true;
      this.$axios
        .fetchPost(api.login, qs.stringify(this.form), {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          loginType: 10
        })
        .then(data => {
          this.loading = false;
          if (data.code == 200) {
            // if (this.rememberUser) {
            //   this.$utils.setUserName(this.form.username);
            // } else {
            //   this.$utils.clearUserName();
            // }
            this.$utils.setSysUser(data.data.user || {});
            this.$utils.setUserMenu(data.data.menu || {});
            this.$utils.setSessionID(data.data.key);
            this.$router.push({path: "/index"});
            this.getCacheData();
            this.setUserInfo();
          } else {
            this.$message({message: data.msg, type: "error"});
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({message: "请求失败！", type: "error"});
          this.loading = false;
        });
    },
    getCacheData() {
      this.$axios.fetchGet(api.getStatus).then(data => {
        this.$utils.setCache(data.data || {});
      });
    },
    // 储存cookie 用户信息
    setUserInfo() {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      if (this.activeName === "first") {
        // if(this.remberPhone){
        //   this.$utils.removeCookie('phone')
        //   this.$utils.setCookie("phone",this.form.username,15)
        // }else{
        //   this.$utils.setCookie("phone","")
        // }
        // if(!this.remberPassword){
        //   this.$utils.setCookie("username1","")
        //   this.$utils.setCookie("username2","")
        // }else{
        //   this.$utils.setCookie("username1",this.$utils.getCookie("username1"),15)
        //   this.$utils.setCookie("username2",this.$utils.getCookie("username2"),15)
        // }
        if (this.remberPassword) {
          this.$utils.removeCookie("phone");
          this.$utils.setCookie("phone", this.form.username, 15);
          this.$utils.setCookie(
            "username1",
            this.$utils.getCookie("username1"),
            15
          );
          this.$utils.setCookie(
            "username2",
            this.$utils.getCookie("username2"),
            15
          );
        } else {
          this.$utils.setCookie("phone", "");
        }
      } else {
        // if(this.remberPassword){
        //   this.$utils.removeCookie('username1')
        //   this.$utils.removeCookie('username2')
        //   this.$utils.setCookie("username1",this.form.merchantNo,15)
        //   this.$utils.setCookie("username2",this.form.username,15)
        // }else{
        //   this.$utils.setCookie("username1","")
        //   this.$utils.setCookie("username2","")
        // }
        // if(!this.remberPhone){
        //   this.$utils.setCookie("phone","")
        // }else{
        //   this.$utils.setCookie("phone",this.$utils.getCookie("phone"),15)
        // }
        if (this.remberPassword) {
          this.$utils.removeCookie("username1");
          this.$utils.removeCookie("username2");
          this.$utils.setCookie("username1", this.form.merchantNo, 15);
          this.$utils.setCookie("username2", this.form.username, 15);
          this.$utils.setCookie("phone", this.$utils.getCookie("phone"), 15);
        } else {
          this.$utils.setCookie("username1", "");
          this.$utils.setCookie("username2", "");
        }
      }
    }
  }
};
</script>
<style>
.login-bg {
  width: 100%;
  height: 100%;
  min-height: 700px;
  min-width: 1200px;
  background-image: url("../assets/images/login-bg2.png");
  background-size: 100% 100%;
}
.login-bg .regist {
  color: #fff;
  text-align: center;
}
.login-bg .rember-pwd {
  min-height: unset;
}
.login-bg .login-box {
  width: 30vw;
  position: absolute;
  top: 25vh;
  left: 35vw;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

.login-bg .title {
  font-size: 20px;
  color: #fff;
  text-align: center;
  position: absolute;
  width: 100%;
  text-align: center;
  top: calc(25vh - 40px);
}

.login-bg .logo {
  position: absolute;
  left: calc(50vw - 108px);
  top: calc(25vh - 100px);
  width: 180px;
  height: 35px;
  background-image: url(../assets/images/logo.png);
  background-size: 100% 100%;
}

.login-bg .el-form-item__content {
  width: 90%;
  margin: 0 auto;
  line-height: 40px;
}

.login-bg .el-input--prefix .el-input__inner {
  padding-left: 40px;
}

.login-bg .el-form-item__content .el-input__inner {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  height: 45px;
  box-sizing: border-box;
  border-radius: 4px;
}

.login-bg .login-btn {
  width: 100%;
  border-radius: 5px;
  border: 0px;
  height: 40px;
  font-weight: bolder;
  letter-spacing: 5px;
}

.login-bg .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #fff;
}

.login-bg .el-checkbox .el-checkbox__inner {
  border-color: #fff;
  background-color: transparent;
}
.login-bg .el-tabs__nav-wrap::after {
  display: none;
}

.login-bg .el-tabs__item {
  color: #fff;
  padding-left: 0;
}

.login-bg .el-checkbox__inner::after {
  border-color: #409eff;
}

.login-bg .el-tabs__active-bar {
  bottom: 5px;
  width: 34px !important;
  left: 10px;
}
.login-bg .el-tabs__item.is-active,
.login-bg .el-tabs__item:hover {
  color: #409eff;
  border: 0;
}

.login-bg .el-checkbox .el-checkbox__label {
  color: #fff;
  font-size: 12px;
}

.login-bg .el-input__icon {
  line-height: 47px;
  font-size: 22px;
}

.login-bg .el-input {
  width: 100%;
  margin-bottom: 20px;
  height: 100%;
}

.check-item {
  text-align: right;
  margin-top: -10px;
}
.login-bg .rember-password {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.login-bg a {
  color: #fff;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue